import { render, staticRenderFns } from "./EventsAdmin.vue?vue&type=template&id=fb2aaf1e&scoped=true"
import script from "./EventsAdmin.vue?vue&type=script&lang=js"
export * from "./EventsAdmin.vue?vue&type=script&lang=js"
import style0 from "./EventsAdmin.vue?vue&type=style&index=0&id=fb2aaf1e&prod&scoped=true&lang=css"
import style1 from "./EventsAdmin.vue?vue&type=style&index=1&id=fb2aaf1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2aaf1e",
  null
  
)

export default component.exports